'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $scope, Upload, toaster, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$scope = $scope;
    this.Upload = Upload;
    this.toaster = toaster;
    this.$stateParams = $stateParams;

    this.tutorial = {};
  }

  $onInit() {
    this.getTutorials(this.$stateParams.id);

    this.$scope.$watch('tEditCtrl.file', (file) => {
      if (file !== undefined && file !== null) {
        this.upload(file);
      }
    });
  }

  getTutorials(id) {
    this.$http.get(`/api/tutorials/${id}`).then(res => {
      this.tutorial = res.data;
    });
  }

  upload(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: '/api/tutorials/upload',
      file: file,
      data: this.tutorial,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.$state.go('tutorial');
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  update() {
    this.$http.put(`/api/tutorials/${this.$stateParams.id}`, this.tutorial).then(res => {
      this.$state.go('tutorial');
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/tutorial/edit/edit.controller.js